// Re-exported from @myrealtrip/messenger-core
export {
  INPUT_MESSAGE_PLACEHOLDER,
  INPUT_MESSAGE_PLACEHOLDER_DISABLED,
  INPUT_MESSAGE_PLACEHOLDER_ALONE_DISABLED,
  CONFIRM_RESEND_MESSAGE,
  MEMBER_LEFT_MESSAGE,
  MessageErrorType,
  ErrorMessages,
  MessageType,
  SendBirdErrorCode,
  SendingStatus,
  SendingStatusText,
  SendbirdMemberStateFilter,
  SendbirdChannelListOrder,
  CHATBOT_CUSTOM_TYPE,
  CHATBOT_FALLBACK_NICKNAME,
  CHATBOT_PROFILE_ICON_NAME,
} from '@myrealtrip/messenger-core';

export type {
  SendBirdMessage,
  SendBirdMessages,
  SendbirdResponses,
  MediaViewer,
  SendbirdContextProps,
  ChatbotMessageData,
} from '@myrealtrip/messenger-core';
